import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/UploadBrandMaster';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const UploadBrandMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Brand Master - Upload</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

UploadBrandMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadBrandMaster);
